module.exports = __webpack_public_path__ + "img/Weer.77ce9945.jpg";